module.exports = __webpack_public_path__ + "static/media/JiggyLogoTransparent.ba0c558a.png";